/* istanbul ignore file */
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {Alignment} from '../../constants';

const enum FlexAlignment {
  FlexStart = 'flex-start',
  FlexEnd = 'flex-end',
  Center = 'center',
}

export const getProductOptionsCustomCssVars = (customCssVarsFnParams: CustomCssVarsFnParams) => {
  const {styleParams, isRTL} = customCssVarsFnParams;

  const getProductDetailsFlexAlignment = () => {
    const defaultAlignmentRtl = isRTL ? Alignment.RIGHT : Alignment.LEFT;
    switch (styleParams.strings.productPage_productDetailsAlignment?.value || defaultAlignmentRtl) {
      case Alignment.LEFT:
        return isRTL ? FlexAlignment.FlexEnd : FlexAlignment.FlexStart;
      case Alignment.RIGHT:
        return isRTL ? FlexAlignment.FlexStart : FlexAlignment.FlexEnd;
      case Alignment.CENTER:
        return FlexAlignment.Center;
    }
  };

  const flexAlignment = getProductDetailsFlexAlignment();

  const OPTIONS_BASE_FONT_SIZE = 14;
  const optionsFontSize =
    parseFloat(`${styleParams.fonts?.productPage_optionsFontStyle?.size}`) || OPTIONS_BASE_FONT_SIZE;
  const stickyOptionsTextSizeScale = styleParams.numbers.productPage_stickyContainerOpenOptionsTextSize ?? 100;
  const stickyOptionsTextSize = (optionsFontSize * stickyOptionsTextSizeScale) / 100;

  return {
    errorMessageFlexAlignment: flexAlignment,
    productDetailsFlexAlignment: flexAlignment,
    stickyOptionsTextSize,
  };
};
